import { render, staticRenderFns } from "./compareProjectBom.vue?vue&type=template&id=659a79f6&scoped=true&"
import script from "./compareProjectBom.vue?vue&type=script&lang=js&"
export * from "./compareProjectBom.vue?vue&type=script&lang=js&"
import style0 from "./compareProjectBom.vue?vue&type=style&index=0&id=659a79f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659a79f6",
  null
  
)

export default component.exports